import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/service/http/http.service';

export interface ProcessedPmsYears {
  pmsYears: { year: string }[]; // Array of year objects
  defaultYear: string; // The default year based on the fiscal year type
}

@Injectable({
  providedIn: 'root'
})
export class PmsYearService {
  constructor(private httpService: HttpService) {}

  // Fetch PMS year list
  getPmsYearList(url: string, companyId: string): Observable<any> {
    return  this.httpService.callGetService(`${url}${companyId}`);
  }

  // Process PMS year data
  processPmsYears(data: any, fiscalYearType: string): ProcessedPmsYears {
    const currentYear = new Date().getFullYear();
    const pmsYears: { year: string }[] = [];
 
    data?.data?.yearRanges?.forEach((ele: any) => {
      const yearParts = ele.split('_');
      const yearRange = { year: `${yearParts[0]}-${yearParts[1]}`};

      const fromYear = parseInt(yearParts[0]);
      const toYear = parseInt(yearParts[1]);
      if (toYear <= currentYear) {
        pmsYears.push(yearRange);
      }
    });
    
    const defaultYear = fiscalYearType === 'Jan_Dec'? `${currentYear}-${currentYear}`: pmsYears[1].year;
   
    return {
      pmsYears,
      defaultYear
    };
  }

  
  //----------------------Attrition-----------------------------------------
  xAxisLabels: string[] = [];

  updateXAxisLabels(labels: string[]): void {
    this.xAxisLabels = labels;
  }

  getXAxisLabels(): string[] {
    return this.xAxisLabels;
  }

}
